import React, { memo, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { validators, objects } from "investira.sdk";
import { Stack, Box, Typography, Card, CircularProgress, Button, Icon, Divider } from "investira.react.components";
import { InlineInfo, PessoaImage } from "../../../components/molecules";
import services from "../../../services";
import { PATHS } from "../../../enums";
import { displays } from "investira.react.lib";
const AtivosSemelhantes = memo(props => {
  const {
    ativo
  } = props;
  const params = useParams();
  const [ativos, setAtivos] = useState([]);
  const [isLoading, setLoading] = useState(true);
  function setParams(pAtivo) {
    const {
      mercado,
      ativo_tipo_id,
      emissor_setor_id,
      emissor_top_setor_id
    } = pAtivo;
    const xParams = {
      mercado,
      ativo_tipo_id,
      emissor_setor_id,
      emissor_top_setor_id,
      cancelado: "null",
      logo: 1,
      logo_ok: 1,
      fracionario: false,
      acao_especie: "O" // P
    };
    return xParams;
  }
  function seeAllUrl(pAtivo) {
    const {
      mercado,
      ...restParams
    } = setParams(pAtivo);
    const xPath = PATHS[mercado.toLowerCase()].path;
    return `/ativos${xPath}${objects.objectToQueryString({
      ...restParams
    })}`;
  }
  function filterResponse(pReponse, pAtivoId) {
    return pReponse.filter(xAtivo => {
      return xAtivo.ativo_id !== Number(pAtivoId);
    }).slice(0, 12);
  }
  useEffect(() => {
    if (params.id) {
      setLoading(true);
      const xParams = setParams(ativo);
      services.ativosbase.list({
        ...xParams,
        size: 13,
        sort: "relevancia DESC, mercado ASC"
      }, rRes => {
        setAtivos(filterResponse(Object.values(rRes.data), params.id));
      }, null, () => {
        setLoading(false);
      });
    }

    //return () => services.ativos.list.cancel();
  }, [params.id, ativo]);
  if (isLoading) {
    return <Stack justifyContent="center" alignItems="center" flexGrow={1} sx={{
      py: 2,
      height: "100%"
    }}>
        <CircularProgress size={24} />
      </Stack>;
  }
  if (ativos.length === 0) {
    return null;
  }
  return <Stack spacing={2} sx={{
    py: 2
  }}>
      <Stack direction="row">
        <Stack>
          <Typography variant="h6" color="textPrimary">
            Ativos Semelhantes
          </Typography>
        </Stack>
        <Stack flexGrow="1"></Stack>
        <Stack>
          <Button component={Link} endIcon={<Icon iconName="arrow-next" size={12} />} to={seeAllUrl(ativo)} size="small" sx={{
          px: 2
        }}>
            Ver todos
          </Button>
        </Stack>
      </Stack>
      <Box sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "repeat(1, 1fr)",
        sm: "repeat(2, 1fr)",
        md: "repeat(4, 1fr)"
        //lg: "repeat(5, 1fr)",
      },
      gap: 1.5
    }}>
        {!validators.isEmpty(ativos) && ativos.map(xAtivo => {
        const {
          vencimento,
          logo_pessoa_id,
          logo_ok,
          mercado,
          ativo_seuid,
          ativo,
          pessoa_id,
          ifeed_ativo_id,
          isin,
          ticker,
          ativo_auxid,
          serie,
          emissor_cnpj
        } = xAtivo;
        const xPath = PATHS[mercado.toLowerCase()].path;
        return <Card key={pessoa_id}>
                <Link to={`/ativos${xPath}/${ifeed_ativo_id}`}>
                  <Stack px={2} py={2} spacing={2} justifyContent="space-between" flexGrow={1} height="100%">
                    <Stack spacing={2}>
                      <Stack>
                        <PessoaImage logoPessoaId={logo_pessoa_id} alt={ativo_seuid} hasLogo={logo_ok} mercado={mercado} size={40} />
                      </Stack>
                      <Stack flexGrow={1}>
                        <Stack flexGrow={1}>
                          <Typography variant="caption" color="textPrimary" sx={{
                      fontWeight: 600
                    }}>
                            {ticker || ativo_seuid || ativo}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Divider />
                    <Stack spacing={0.5}>
                      <InlineInfo label="ISIN" value={isin} copy={"muted"} divider={false} />
                      <InlineInfo label="CIF" value={ativo_auxid} copy={"muted"} divider={false} helpText="Código Instrumento Financeiro: Este é um código alternativo fornecido pelo emissor." />
                      <InlineInfo label="CNPJ" value={displays.cnpj(emissor_cnpj)} copy={"muted"} divider={false} />
                      <InlineInfo label="Venc." value={vencimento} variant="date" copy={"muted"} divider={false} />
                      <InlineInfo label="Série" value={serie} copy={"muted"} divider={false} />
                    </Stack>
                  </Stack>
                </Link>
              </Card>;
      })}
      </Box>
    </Stack>;
});
export default AtivosSemelhantes;
